export interface Country {
  code: string;
  name: string;
  phoneCode?: string;
}

export const countries: Country[] = [
  { code: "AF", name: "Afghanistan", phoneCode: "+93" },
  { code: "AL", name: "Albania", phoneCode: "+355" },
  { code: "DZ", name: "Algeria", phoneCode: "+213" },
  { code: "AR", name: "Argentina", phoneCode: "+54" },
  { code: "AU", name: "Australia", phoneCode: "+61" },
  { code: "AT", name: "Austria", phoneCode: "+43" },
  { code: "BE", name: "Belgium", phoneCode: "+32" },
  { code: "BR", name: "Brazil", phoneCode: "+55" },
  { code: "CA", name: "Canada", phoneCode: "+1" },
  { code: "CL", name: "Chile", phoneCode: "+56" },
  { code: "CN", name: "China", phoneCode: "+86" },
  { code: "CO", name: "Colombia", phoneCode: "+57" },
  { code: "CR", name: "Costa Rica", phoneCode: "+506" },
  { code: "HR", name: "Croatia", phoneCode: "+385" },
  { code: "CZ", name: "Czech Republic", phoneCode: "+420" },
  { code: "DK", name: "Denmark", phoneCode: "+45" },
  { code: "EC", name: "Ecuador", phoneCode: "+593" },
  { code: "EG", name: "Egypt", phoneCode: "+20" },
  { code: "FI", name: "Finland", phoneCode: "+358" },
  { code: "FR", name: "France", phoneCode: "+33" },
  { code: "DE", name: "Germany", phoneCode: "+49" },
  { code: "GR", name: "Greece", phoneCode: "+30" },
  { code: "HK", name: "Hong Kong", phoneCode: "+852" },
  { code: "HU", name: "Hungary", phoneCode: "+36" },
  { code: "IN", name: "India", phoneCode: "+91" },
  { code: "ID", name: "Indonesia", phoneCode: "+62" },
  { code: "IE", name: "Ireland", phoneCode: "+353" },
  { code: "IL", name: "Israel", phoneCode: "+972" },
  { code: "IT", name: "Italy", phoneCode: "+39" },
  { code: "JP", name: "Japan", phoneCode: "+81" },
  { code: "KR", name: "South Korea", phoneCode: "+82" },
  { code: "MY", name: "Malaysia", phoneCode: "+60" },
  { code: "MX", name: "Mexico", phoneCode: "+52" },
  { code: "NL", name: "Netherlands", phoneCode: "+31" },
  { code: "NZ", name: "New Zealand", phoneCode: "+64" },
  { code: "NO", name: "Norway", phoneCode: "+47" },
  { code: "PK", name: "Pakistan", phoneCode: "+92" },
  { code: "PA", name: "Panama", phoneCode: "+507" },
  { code: "PE", name: "Peru", phoneCode: "+51" },
  { code: "PH", name: "Philippines", phoneCode: "+63" },
  { code: "PL", name: "Poland", phoneCode: "+48" },
  { code: "PT", name: "Portugal", phoneCode: "+351" },
  { code: "RO", name: "Romania", phoneCode: "+40" },
  { code: "RU", name: "Russia", phoneCode: "+7" },
  { code: "SA", name: "Saudi Arabia", phoneCode: "+966" },
  { code: "SG", name: "Singapore", phoneCode: "+65" },
  { code: "ZA", name: "South Africa", phoneCode: "+27" },
  { code: "ES", name: "Spain", phoneCode: "+34" },
  { code: "SE", name: "Sweden", phoneCode: "+46" },
  { code: "CH", name: "Switzerland", phoneCode: "+41" },
  { code: "TW", name: "Taiwan", phoneCode: "+886" },
  { code: "TH", name: "Thailand", phoneCode: "+66" },
  { code: "TR", name: "Turkey", phoneCode: "+90" },
  { code: "UA", name: "Ukraine", phoneCode: "+380" },
  { code: "AE", name: "United Arab Emirates", phoneCode: "+971" },
  { code: "GB", name: "United Kingdom", phoneCode: "+44" },
  { code: "US", name: "United States", phoneCode: "+1" },
  { code: "UY", name: "Uruguay", phoneCode: "+598" },
  { code: "VE", name: "Venezuela", phoneCode: "+58" },
  { code: "VN", name: "Vietnam", phoneCode: "+84" },
];

export function getCountryName(code: string): string {
  const country = countries.find(c => c.code === code);
  return country?.name || code;
}

export function getPhoneCode(countryCode: string): string {
  const country = countries.find(c => c.code === countryCode);
  return country?.phoneCode || "";
}

export function isBrazil(countryCode: string): boolean {
  return countryCode === "BR" || countryCode === "brazil";
}
